import { render } from "./Artboard_Osmium.vue?vue&type=template&id=24af76fa&scoped=true"
import script from "./Artboard_Osmium.vue?vue&type=script&lang=js"
export * from "./Artboard_Osmium.vue?vue&type=script&lang=js"

import "./Artboard_Osmium.vue?vue&type=style&index=0&id=24af76fa&scoped=true&lang=css"
import "./Artboard_Osmium.vue?vue&type=style&index=1&id=24af76fa&lang=css"
script.render = render
script.__scopeId = "data-v-24af76fa"

export default script